// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 0.5H8V3H3V23.5H21V3H16V0.5ZM16 14.5H13V17.5H11V14.5H8V12.5H11V9.5H13V12.5H16V14.5Z"}}]};

const BatteryAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'battery-add-filled',
    ref,
    icon: element,
  },
));

BatteryAddFilledIcon.displayName = 'BatteryAddFilledIcon';

export default BatteryAddFilledIcon;
